import React, { forwardRef, useImperativeHandle, useState, useEffect } from 'react';
import { Dropdown } from 'primereact/dropdown';
import "primereact/resources/themes/lara-light-cyan/theme.css";
import sublist from '../mock/sublist.json';
import { Endpoints } from "../constants/env/middletier";

const SubDropdown = forwardRef(function SubDropdown(
  { onSubChange },
  ref
) {






// function SubDropdown({ onSubChange, resetDropdown }) {
    const [subs, setSubList] = useState([]);
    const [selectedSub, setSelectedSub] = useState(null);


    useImperativeHandle(ref, () => ({
        reset() {
            setSelectedSub(null);
        }
    }));

    useEffect(() => {
        fetch(Endpoints["subs"])  // Replace with your actual endpoint
          .then((res) => res.json())
          .then((data) => {
            const mappedSubs = data.map((teacher) => ({
              name: `${teacher.firstName} ${teacher.lastName}`,
              id: teacher.id
            }));
            setSubList(mappedSubs);
          })
          .catch((err) => console.error('Failed to load substitutes:', err));
    }, []);

//<select>
//  <option value="">Select a teacher</option>
//  {subs.map((teacher) => (
//    <option key={teacher.id} value={teacher.id}>
//      {teacher.first_name} {teacher.last_name}
//    </option>
//  ))}
//</select>

    const handleChange = (e) => {
//        console.log(e);
        const sub = e.value;
        setSelectedSub(sub);
        onSubChange(sub); // notify parent
    };

    return (
        <>
            <div className="card flex justify-content-center">
                <Dropdown
                    value={selectedSub}
                    onChange={handleChange}
                    options={subs}
                    filter
                    showClear
                    optionLabel="name"
                    placeholder="Select a Substitute" />
            </div>


        </>
    );
});

export default SubDropdown;